module.exports = __webpack_public_path__ + "img/28afb880dbb5421c8c715f0b1ae8c7d8.f15aebc2.png";